var appStores = angular.module('app-helpers', []);

appStores.factory('helpers', ['$document', '$http', function ($document, $http) {
    var factory = {};
    var _imagesToPartnumbers = [];
    //var _country = country;
    //if (window.countryId == 19) {
    //    _country += ' Guernsey, Jersey, Isle of man';
    //}

    factory.getGeolocation = function (address, callback) {
        getLatLng(address + ' ' + (window.containsRelatedCountryIds == undefined ? country : ''), function (lat, lng) {
            if (lat != undefined) {
                if (callback) {
                    callback(lat, lng);
                }
            } else {
                //try to find without country suffix
                getLatLng(address, function (lat, lng) {
                    if (callback) {
                        callback(lat, lng);
                    }
                })
            }
        })
    }

    var browserLocation;
    var gettingBrowserLocation = false;

    var check = function (callback) {
        if (gettingBrowserLocation == false) {
            // run when condition is met
            if (browserLocation != undefined) {
                if (callback) {
                    callback(browserLocation.lat, browserLocation.lng, browserLocation.dealercity);
                }
            } else {
                return true;
            }
        }
        else {
            log('wait for browser location acceptance');
            setTimeout(function () {
                check(callback);
            }, 500); // check again in a second
        }
    }

    var browserLocationSuccess = function (position, callback) {
        var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ latLng: latlng }, function (results, status) {
            var dealercity = '';
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[1]) {
                    var arrAddress = results;
                    log(results);
                    $.each(arrAddress, function (i, address_component) {
                        if (address_component.types[0] == "locality") {
                            log("dealercity: " + address_component.address_components[0].long_name);
                            dealercity = address_component.address_components[0].long_name;
                        }
                    });
                    if (dealercity.length == 0) {
                        //try to find by administrative_area_level_4
                        $.each(arrAddress, function (i, address_component) {
                            if (address_component.types[0] == "administrative_area_level_4") {
                                log("dealercity: " + address_component.address_components[0].long_name);
                                dealercity = address_component.address_components[0].long_name;
                            }
                        });
                    }
                    if (dealercity.length == 0) {
                        //try to find by postal_town
                        $.each(arrAddress, function (i, address_component) {
                            if (address_component.types[0] == "postal_town") {
                                log("dealercity: " + address_component.address_components[0].long_name);
                                dealercity = address_component.address_components[0].long_name;
                            }
                        });
                    }
                } else {
                    dealercity = lblNoLocationFound;
                }
            } else {
                //Raygun.send("Google Maps Geocoder exception. Status: " + status);
                dealercity = "Geocoder failed due to: " + status;
            }

            browserLocation = { lat: position.coords.latitude, lng: position.coords.longitude, dealercity: dealercity };
            gettingBrowserLocation = false;

            if (callback && dealercity.length > 0) {
                callback(position.coords.latitude, position.coords.longitude, dealercity);
            }
        });
    }

    factory.getBrowserLocation = function (callback, lookup, progressBarToggle) {
        if (lookup == undefined || lookup == null || lookup == true) {

            if (check(callback)) {
                //wait to try again
                if (navigator.geolocation) {
                    gettingBrowserLocation = true;
                    if (progressBarToggle) {
                        progressBarToggle();
                    }
                    navigator.geolocation.getCurrentPosition(function (position) {
                        browserLocationSuccess(position, callback);
                        if (progressBarToggle) {
                            progressBarToggle();
                        }
                    }, function (error) {
                        browserLocation = { lat: window.defaultLatitude, lng: window.defaultLongitude, dealercity: window.defaultCityEnglish };
                        gettingBrowserLocation = false;
                        callback(window.defaultLatitude, window.defaultLongitude, window.defaultCityEnglish, true);
                        log(error);

                        if (progressBarToggle) {
                            progressBarToggle();
                        }
                    }, { timeout: 5000 });//5sec
                }
            }
        } else {
            callback();
        }
    }

    //factory.getBrowserLocation = function (callback, lookup) {
    //    if (lookup == undefined || lookup == null || lookup == true) {
    //        if (navigator.geolocation) {
    //            navigator.geolocation.getCurrentPosition(function (position) {

    //                var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
    //                //latlng = new google.maps.LatLng(52.706926, -1.093812);
    //                var geocoder = new google.maps.Geocoder();
    //                geocoder.geocode({ latLng: latlng }, function (results, status) {
    //                    var dealercity = '';
    //                    if (status == google.maps.GeocoderStatus.OK) {
    //                        if (results[1]) {
    //                            var arrAddress = results;
    //                            log(results);
    //                            $.each(arrAddress, function (i, address_component) {
    //                                if (address_component.types[0] == "locality") {
    //                                    log("dealercity: " + address_component.address_components[0].long_name);
    //                                    dealercity = address_component.address_components[0].long_name;
    //                                }
    //                            });
    //                            if (dealercity.length == 0) {
    //                                //try to find by administrative_area_level_4
    //                                $.each(arrAddress, function (i, address_component) {
    //                                    if (address_component.types[0] == "administrative_area_level_4") {
    //                                        log("dealercity: " + address_component.address_components[0].long_name);
    //                                        dealercity = address_component.address_components[0].long_name;
    //                                    }
    //                                });
    //                            }
    //                            if (dealercity.length == 0) {
    //                                //try to find by postal_town
    //                                $.each(arrAddress, function (i, address_component) {
    //                                    if (address_component.types[0] == "postal_town") {
    //                                        log("dealercity: " + address_component.address_components[0].long_name);
    //                                        dealercity = address_component.address_components[0].long_name;
    //                                    }
    //                                });
    //                            }
    //                        } else {
    //                            dealercity = lblNoLocationFound;
    //                        }
    //                    } else {
    //                        //Raygun.send("Google Maps Geocoder exception. Status: " + status);
    //                        dealercity = "Geocoder failed due to: " + status;
    //                    }

    //                    if (callback && dealercity.length > 0) {
    //                        callback(position.coords.latitude, position.coords.longitude, dealercity);
    //                    }
    //                });
    //            }, function (error) {
    //                callback(window.defaultLatitude, window.defaultLongitude);
    //                //if (error.code == error.PERMISSION_DENIED) {
    //                //    // pop up dialog asking for location
    //                //}
    //            }, { timeout: 5000 });//5sec
    //        }
    //    } else {
    //        callback();
    //    }
    //}

    factory.__envMobile = undefined;
    factory.isMobile = function () {
        if (factory.__envMobile !== undefined)
            return factory.__envMobile;

        var envs = ['xs', 'sm', 'md', 'lg'];

        var el = angular.element('<div>');
        $document.find('body').append(el);

        for (var i = envs.length - 1; i >= 0; i--) {
            var env = envs[i];

            el.addClass('hidden-' + env);
            if (el.is(':hidden')) {
                el.remove();
                factory.__envMobile = env === 'xs';

                return factory.__envMobile;
            }
        }
    };

    factory.setImagesToPartnumbers = function (imagesToPartnumbers) {
        _imagesToPartnumbers = imagesToPartnumbers;
    };

    factory.getImagesToPartnumbers = function () {
        return _imagesToPartnumbers;
    };

    factory.validateAddress = function (street, postalcode, city, email, phone, state, loqateKey, abortWhenCountryIsInvalid, _callbackKeep, _callbackUpdate, _callbackEnd) {
        var url = '/' + window.culture + '/validate-address'
        $http({
            method: 'POST',
            url: url,
            cache: false,
            withCredentials: true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            transformRequest: function (obj) {
                //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                var str = [];
                for (var p in obj)
                    if (obj[p] != null) {
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    }
                return str.join("&");
            },
            data: { Street: street, PostalCode: postalcode, City: city, Email: email, Phone: phone, State: state, LoqateKey: loqateKey, AbortWhenCountryIsInvalid: abortWhenCountryIsInvalid},
        }).then(function (res) {
            if (_callbackEnd) {
                _callbackEnd(res.data);
            }
            if (res.data != null) {
                if (res.data.Result == false) {
                    $('#validationAddress').hide();
                    $('#validationCountry').hide();
                    $('#validationEmail').hide();
                    $('#validationPhone').hide();
                    $('#btnAddressSearchUpdate').hide();
                    $('#btnAddressCancel').hide();
                    $('#btnAddressSearchKeep').show();
                    $('#btnAddressSearchKeep').off('click');
                    $('#btnAddressSearchUpdate').off('click');

                    $('#btnAddressSearchKeep').on('click', function () {
                        if (_callbackKeep) {
                            _callbackKeep();
                        }
                    });

                    for (var i = 0; i < res.data.Validations.length; i++) {
                        if (res.data.Validations[i].Type == 'address' && res.data.Validations[i].Address.CountryIso2 == window.countryCode.toUpperCase()) {
                            var address = res.data.Validations[i].Address;
                            $('#street_filled').text(street);
                            $('#postalcode_filled').text(postalcode);
                            $('#city_filled').text(city);
                            $('#state_filled').text(state);
                            $('#street_suggestion').text(address.Line1);
                            $('#postalcode_suggestion').text(address.PostalCode);
                            $('#city_suggestion').text(address.City);
                            $('#state_suggestion').text(address.ProvinceCode);

                            $('#validationAddress').show();
                            $('#btnAddressSearchUpdate').show();

                            $('#btnAddressSearchUpdate').on('click', function () {

                                if (_callbackUpdate) {
                                    _callbackUpdate(address);
                                }
                            });
                            //} else {
                            //    $('#CountryValidateFailedModal').modal('show');
                        }

                        if (res.data.Validations[i].Type == 'address' && res.data.Validations[i].Address.CountryIso2 != window.countryCode.toUpperCase()) {
                            $('#validationCountry').show();
                            $('#btnAddressCancel').show();
                            $('#btnAddressSearchKeep').hide();
                        }

                        if (res.data.Validations[i].Type == 'email') {
                            $('#email_filled').text(email);
                            $('#validationEmail').show();
                            if (res.data.Validations.length == 1) {
                                //only show this button when address is correct and only email address is incorrect
                                $('#btnAddressCancel').show();
                            }
                        }
                        else if (res.data.Validations[i].Type == 'phone') {
                            $('#phone_filled').text(phone);
                            $('#validationPhone').show();
                            $('#btnAddressCancel').show();
                            $('#btnAddressSearchKeep').hide();
                        }

                        $('#AddressValidateFailedModal').modal('show');

                    }
                    return;
                }
            }
            if (_callbackKeep) {
                _callbackKeep();
            }
        });
    };

    factory.isValidOrderPhone = function (phone) {
        if (window.orderPhoneValidationActive != true || phone == null || phone.length == 0)
            return true;

        if (window.countryId == 17) {
            if (phone.indexOf('.') > -1 || phone.indexOf('-') > -1)
                return false;

            var digits = phone.replace(/[^\d]/g, '');
            if (digits.indexOf('0048') === 0)
                digits = digits.substring(4);
            else if (digits.indexOf('48') === 0 && digits.length > 9)
                digits = digits.substring(2);

            return digits.length === 9 && digits.charAt(0) !== '0';
        }

        return true;
    };

    return factory;
}]);